import { useQuery } from '@tanstack/react-query';

import { baseAPI } from './base-api';
import { KEYS } from './query-keys';

export interface GHLCalendar {
  id: string;
  name: string;
}

interface GHLCalendarsResponse {
  calendars: GHLCalendar[];
}

export const getGHLCalendarsAPI = async (): Promise<GHLCalendar[]> => {
  const response = await baseAPI.get<GHLCalendarsResponse>('/ghl_auth/calendars');
  return response.data?.calendars ?? [];
};

export const useGetGHLCalendars = () =>
  useQuery({
    queryKey: [KEYS.GHL_CALENDARS],
    queryFn: getGHLCalendarsAPI,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
